import Icon from "@mui/icons-material/Payments";
import { ProjectKarzanRepaymentList } from "./ProjectKarzanRepaymentList";
import { ProjectKarzanRepaymentCreate } from "./ProjectKarzanRepaymentCreate";
import { ProjectKarzanRepaymentEdit } from "./ProjectKarzanRepaymentEdit";

export default {
  list: ProjectKarzanRepaymentList,
  create: ProjectKarzanRepaymentCreate,
  edit: ProjectKarzanRepaymentEdit,
  icon: Icon,
  label: "Karzan repayments",
  options: { label: "Karzan repayments" },
  name: "projectKarzanRepayments",
};
